import React from "react";

import { CheckCircleIcon, CloseCircleIcon } from "../../icons";

import "./WhyChooseIntensive.css";

export default function WhyChooseIntensive() {
  return (
    <>
      <section className="section-2810">
          <div className="w-layout-blockcontainer intensive-container w-container">
            <div className="div-block-1831980521448938">
              <h2 className="h2-heading">Why Choose NxtWave Intensive?</h2>
              <div className="div-block-1831980521448937">
                <div className="div-block-1831980521448966"><img loading="lazy" src="https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/intensive-english/nxtwave-intensive-logo.svg" alt="Text logo reading &#x27;NXT WAVE INTENSIVE&#x27; in stylized blue and purple letters." className="intensive-offline-logo" /></div>
                <div className="text-block-941288240620">Other Institutes</div>
                <div id="w-node-e0555478-b343-c066-8dac-2c226ebb88f3-fe44dbd2" className="about-intensive-card">
                  <div className="div-block-1831980521448936"><CheckCircleIcon /></div>
                  <div>Curriculum designed to meet current companies’ requirements</div>
                </div>
                <div id="w-node-_1495797e-fbbe-a2a0-6712-b9651ab26f7e-fe44dbd2" className="about-others-card">
                  <div className="div-block-1831980521448936"><CloseCircleIcon /></div>
                  <div>Outdated, not aligned with<br />hiring needs</div>
                </div>
                <div id="w-node-_4ae2f3d0-8bf6-ee89-dbb1-6bf7617e1fab-fe44dbd2" className="about-intensive-card">
                  <div className="div-block-1831980521448936"><CheckCircleIcon /></div>
                  <div>Hands-on, digital learning through advanced learning portal</div>
                </div>
                <div id="w-node-e81726e5-d49d-854f-35ae-1df44213f7fb-fe44dbd2" className="about-others-card">
                  <div className="div-block-1831980521448936"><CloseCircleIcon /></div>
                  <div>Lecture-based learning with minimal practical exposure</div>
                </div>
                <div id="w-node-_9ea8fca4-cb83-c836-e04a-4a762ce54359-fe44dbd2" className="about-intensive-card">
                  <div className="div-block-1831980521448936"><CheckCircleIcon /></div>
                  <div>NxtWave-certified trainers &amp;<br />mentors</div>
                </div>
                <div id="w-node-_3bdff585-966e-c535-8c58-20c3ad0be0fd-fe44dbd2" className="about-others-card">
                  <div className="div-block-1831980521448936"><CloseCircleIcon /></div>
                  <div>Mentors with no real-world project experience</div>
                </div>
                <div id="w-node-_68a5cda1-ddd2-bcdc-fe8d-ef8cd5e39f21-fe44dbd2" className="about-intensive-card">
                  <div className="div-block-1831980521448936"><CheckCircleIcon /></div>
                  <div>Live doubt resolution</div>
                </div>
                <div id="w-node-_3d52035a-830c-54b0-073c-57421ce9efea-fe44dbd2" className="about-others-card">
                  <div className="div-block-1831980521448936"><CloseCircleIcon /></div>
                  <div>Limited to short, fixed doubt session</div>
                </div>
                <div id="w-node-_3bdf0199-6e47-6e68-bc78-59a6441f4c56-fe44dbd2" className="about-intensive-card">
                  <div className="div-block-1831980521448936"><CheckCircleIcon /></div>
                  <div>10+ real-time projects</div>
                </div>
                <div id="w-node-_24ba073b-a9dd-7da0-4d53-76ecc9b6294b-fe44dbd2" className="about-others-card">
                  <div className="div-block-1831980521448936"><CloseCircleIcon /></div>
                  <div>1 - 2 basic projects</div>
                </div>
                <div id="w-node-_81ea8640-41e8-d02f-3641-b4bf7467f5c8-fe44dbd2" className="about-intensive-card">
                  <div className="div-block-1831980521448936"><CheckCircleIcon /></div>
                  <div>Dedicated success coaches</div>
                </div>
                <div id="w-node-_09d046d7-3b90-60ca-9597-6da8b70fa24e-fe44dbd2" className="about-others-card">
                  <div className="div-block-1831980521448936"><CloseCircleIcon /></div>
                  <div>Limited or no personalized guidance</div>
                </div>
                <div id="w-node-bcb7a5fc-9dc1-38dd-15c3-d2fa34459e84-fe44dbd2" className="about-intensive-card">
                  <div className="div-block-1831980521448936"><CheckCircleIcon /></div>
                  <div>Complete concept revision</div>
                </div>
                <div id="w-node-a794b9f0-c00b-3a72-6bf3-10562f5b1ae3-fe44dbd2" className="about-others-card">
                  <div className="div-block-1831980521448936"><CloseCircleIcon /></div>
                  <div>Basic revision sessions, not focused on placements</div>
                </div>
              </div>
            </div>
          </div>
        </section>
    </>
  );
}
